import React, { useEffect, useState } from "react";
import {
  getAllotment,
  getToken,
  getUsersByTeams,
  getSelectedProjectByIds,
  getEventBySalesPerson
} from "../../../Services/Dashboard";
import {
  Box,
  Divider,

} from "@mui/material";
import { getAllProjects } from "../../../Services/AssignProject";
import cssClasses from "./CancellationsAndRefunds.module.css";
import Datagrid from "../../../Subcomponents/Datagrid";
import DropDown from "../../../Subcomponents/DropDown";
import LeadStatusChip from "../../../Subcomponents/LeadStatusChip";
import Dot from "../../Icons/Dot";
import { groupBy } from "lodash";
import EmptyListIcon from "../../../Assets/Images/Common/EmptyListLeads.svg";

import CancellationsAndRefundsModal from "../../../Modals/UnitDetailsModal/CancellationsAndRefundsModal";
import { dismissLoader, presentLoader } from "../../../Services/loader";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router";
import CustomAutoComplete from "../../../Subcomponents/CustomAutoComplete";
import { useSelector } from "react-redux";


export default function CancellationsAndRefunds() {
  const loggedInUser = useSelector((state) => state.Auth.user);
  const [allotmentRows, setAllotmentRows] = useState([]);
  const [tokenRows, setTokenRows] = useState([]);
  const [tokenColumns, setTokenColumns] = useState([]);

  const url = window.location.search;
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState(
    url.includes("type")
      ? decodeURIComponent(url.split("?")[4].split("=")[1])
      : "Allotment"
  );
  const [drpDownSubSelectedVal, setDrpDownSubSelectedVal] = useState(
    url.includes("person")
      ? decodeURIComponent(url.split("?")[5].split("=")[1])
      : "All"
  );
  const [drpDownEventSelectedVal, setDrpDownEventSelectedVal] = useState(
    url.includes("event")
      ? decodeURIComponent(url.split("?")[6].split("=")[1])
      : "All"
  );

  const [salesList, setSalesList] = useState([]);
  const [salesNameList, setSalesNameList] = useState([]);

  // const [tokenSalesList, setTokenSalesList] = useState([]);
  const [eventsList, setEventsList] = useState([]);
  const [eventsNameList, setEventsNameList] = useState([]);

  const [tokenData, setTokenData] = useState([]);

  const [unitDetails, setUnitDetails] = useState({});
  const [showUnitDetailsModal, setShowUnitDetailsModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [projects, setProjects] = useState([]);

  const navigate = useNavigate();
  const teamIds = JSON.parse(localStorage.getItem("teamIds"));

  const allotmentProjectHeader = [
    {
      field: "project",
      headerName: "Project",
      width: 250,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-word" }}>{params.row?.project}</div>
        );
      },
    },
    {
      field: "cancellation",
      headerName: "Cancellation",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.project === "Total"
              ? params.row?.cancellation
              : params.row?.cancellation?.length}
          </div>
        );
      },
    },
    {
      field: "area",
      headerName: "Area",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.project === "Total"
              ? params.row?.area
              : `${calculateTotal(params.row?.area, "area")?.toFixed(
                  2
                )} sq.ft`}{" "}
          </div>
        );
      },
    },
    {
      field: "value",
      headerName: "Value",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.project === "Total"
              ? params.row?.value
              : formatNumber(calculateTotal(params.row?.value, "value"))}
          </div>
        );
      },
    },
    {
      field: "cp",
      headerName: "CP",
      width: 150,
      renderCell: (params) => {
        return (
          <div>
            {" "}
            {params.row?.project === "Total"
              ? ""
              : formatNumber(calculateTotal(params.row?.cp, "cp"))}
          </div>
        );
      },
    },

    {
      field: "direct",
      headerName: "Direct",
      width: 200,
      renderCell: (params) => {
        return (
          <div>
            {params.row?.project === "Total"
              ? ""
              : formatNumber(calculateTotal(params.row?.direct, "direct"))}
          </div>
        );
      },
    },
    {
      field: "rAndl",
      headerName: "R & L",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            {params.row?.project === "Total"
              ? ""
              : formatNumber(calculateTotal(params.row?.rAndl, "r&l"))}
          </>
        );
      },
    },
    {
      field: "view",
      headerName: "",
      width: 100,
      renderCell: (params) => {
        return (
          <>
            {params.row?.project === "Total" && <div></div>}

            {params.row?.project !== "Total" && (
              <div
                style={{ marginLeft: "4px", cursor: "pointer" }}
                onClick={() => openInNewIcon(params.row?.view)}
              >
                View
              </div>
            )}
          </>
        );
      },
    },
  ];

  function convertId(idString) {
    const year = idString.slice(0, 4);
    const month = idString.slice(4, 6);
    const day = idString.slice(6, 8);
    const sequence = idString.slice(8);

    const formattedId = `VJ${year}${month}${day}-${sequence}`;

    return formattedId;
  }
  const tokenHeader = [
    {
      field: "leadName",
      headerName: "Lead Name",
      width: 300,
      renderCell: (params) => {
        return (
          <div className={cssClasses.gridData}>
            <p>{params.row?.leadName?.personId?.name}</p>
            <p style={{ opacity: "0.7" }}>
              {params.row?.leadName?.leadDisplayId &&
                convertId(params.row?.leadName?.leadDisplayId)}
            </p>
          </div>
        );
      },
    },
    { field: "eventName", headerName: "Event Name", width: 300 },
    { field: "tokenType", headerName: "Token Type", width: 300 },
    { field: "tokenName", headerName: "Token Name", width: 300 },
    {
      field: "paidAmount",
      headerName: "Paid Amount",
      width: 200,
      renderCell: (params) => {
        const value = params.row?.paidAmount || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },
    {
      field: "refundAmount",
      headerName: "Refund Amount",
      width: 200,
      renderCell: (params) => {
        const value = params.row?.refundAmount || 0;
        return <div className={cssClasses.rupee}>{formatNumber(value)}</div>;
      },
    },

    {
      field: "tokenStatus",
      headerName: "Status",
      width: 250,
      renderCell: (params) => {
        return (
          <>
            {params.row?.tokenStatus?.status && params.row?.paidAmount !== 0 ? (
              <LeadStatusChip
                label={
                  params.row?.tokenStatus?.status?.toLowerCase() ===
                  "refund initiated"
                    ? "Refund Initiated"
                    : params.row?.tokenStatus?.status?.toLowerCase() ===
                      "refund processed"
                    ? "Refund Processed"
                    : params.row?.tokenStatus?.status
                }
                style={
                  params.row?.tokenStatus?.status?.toLowerCase() ===
                  "refund initiated"
                    ? { color: "#027A48", backgroundColor: "#ECFDF3" }
                    : params.row?.tokenStatus?.status?.toLowerCase() ===
                      "refund processed"
                    ? { color: "#B54708", backgroundColor: "#FFFAEB" }
                    : { color: "#B42318", backgroundColor: "#FEF3F2" }
                }
                icon={<Dot width={"0.6rem"} height={"0.6rem"} />}
              />
            ) : params.row?.tokenStatus?.status ? (
              "-"
            ) : (
              ""
            )}
          </>
        );
      },
    },
  ];

  const getProjectIdArr = (projectId) => {
    const projectNameArr = decodeURIComponent(projectId).split(",");
    let arrValue = [];
    if (projectNameArr[0] !== "All") {
      arrValue = projectNameArr.map((name) => {
        const foundObject = projects?.find((obj) => obj.label === name);
        if (foundObject) {
          return foundObject?.value;
        }
      });
    }
    return arrValue;
  };

  const getSalesId = (salesName) => {
    const id =
      salesName === "All"
        ? "All"
        : salesList.find((el) => el?.label === salesName)?.value;
    return id;
  };

  async function getAllAllotment(SalesId) {
    presentLoader();
    let salesId = 0;
    if (SalesId && SalesId !== "All") {
      salesId = getSalesId(SalesId);
    } else {
      salesId = getSalesId(drpDownSubSelectedVal);
    }
    const projectIdArr = getProjectIdArr(
      window.location.search.split("?")[1].split("=")[1]
    );
    if (
      projectIdArr &&
      salesId &&
      (projectIdArr[0] ||
        projectIdArr[0] === "All" ||
        window.location.search.split("?")[1].split("=")[1] === "All")
    ) {
      try {
        let data = await getAllotment(
          projectIdArr,
          window.location.search.split("?")[2].split("=")[1],
          window.location.search.split("?")[3].split("=")[1],
          salesId,
          (loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? null : [loggedInUser?.userId]
        );

        const allotments = data?.filter(
          (el) => el?.leadId?.userId !== null && el?.leadId !== null
        );

        if (allotments) {
          const filterByNull = allotments.filter(
            (el) =>
              el?.leadId?.userId !== null &&
              el?.allotmentPaymentId?.unitId?.projectId !== null
          );

          const groupByProjectId = groupBy(
            filterByNull,
            `allotmentPaymentId.unitId.projectId.projectId`
          );

          const transformedProjectRows = Object.values(groupByProjectId)?.map(
            (el) => ({
              id:
                el[0]?.allotmentPaymentId?.unitId?.projectId?.projectId || "-",
              project:
                el[0]?.allotmentPaymentId?.unitId?.projectId?.projectName ||
                "-",
              cancellation: el,
              area: el,
              value: el,
              cp: el,
              direct: el,
              rAndl: el,
              view: el,
            })
          );

          const totalCancellation = Object.values(groupByProjectId)
            ?.map((el) => el)
            .flat();

          const totalValue = totalCancellation?.reduce((acc, cur) => {
            if (cur?.allotmentPaymentId?.unitCost?.total) {
              return acc + cur?.allotmentPaymentId?.unitCost?.total;
            } else {
              return acc + 0;
            }
          }, 0);

          const totalCalculatedRowAdd = [
            ...transformedProjectRows,
            {
              id: "1",
              project: "Total",
              cancellation: totalCancellation?.length,
              area: "",
              value: formatNumber(totalValue),
              cp: "",
              direct: "",
              rAndl: "",
              view: "",
            },
          ];

          setAllotmentRows(totalCalculatedRowAdd);
            setTimeout(() => {
              dismissLoader();
            }, 300);
        }
        
      } catch (error) {
        console.error("Error fetching allotments:", error);
        dismissLoader();
      }
    }
  }
  const getEventId = (eventName) => {
    const id =
      eventName === "All"
        ? "All"
        : eventsList?.find((el) => el?.label === eventName)?.value;
    return id;
  };

  async function getAllToken(SalesId, EventId) {

    presentLoader();
    let salesId = 0;
    if (SalesId) {
      salesId = getSalesId(SalesId);
    } else {
      salesId = getSalesId(drpDownSubSelectedVal);
    }
    let eventId = 0;
    if (EventId) {
      eventId = getEventId(EventId);
    } else {
      eventId = getEventId(drpDownEventSelectedVal);
    }
    // getEventsData(salesId)

  

    if (salesId && eventId) {
      try {
        let data = await getToken(
          window.location.search.split("?")[2].split("=")[1],
          window.location.search.split("?")[3].split("=")[1],
          salesId,
          eventId,
          (loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? null : [loggedInUser?.userId]
        );

        const tokens = data?.filter(
          (el) => el?.leadId?.userId !== null && el?.leadId !== null
        );

        if (tokens) {
          const filterByNull = tokens.filter(
            (el) => el?.leadId?.userId !== null && el?.eventId !== null
          );

          const filterByStatus = filterByNull;

          const modifiedRefundAmount = [];

          for (let i = 0; i < filterByStatus.length; i++) {

            const refundProcessed = filterByStatus[
              i
            ]?.eventTokenId?.TokenTransactions?.filter(
              (el) => el?.status?.toLowerCase() === "refund processed" && el?.paymentId === filterByStatus[i]?.paymentId
            )?.reduce((acc, cur) => acc + cur.amount, 0);

            const refunded = filterByStatus[
              i
            ]?.eventTokenId?.TokenTransactions?.filter(
              (el) => el?.status?.toLowerCase() === "refunded" && el?.paymentId === filterByStatus[i]?.paymentId
            )?.reduce((acc, cur) => acc + cur.amount, 0);

            const refundAmount = filterByStatus[i]?.status?.toLowerCase() ===
                  "refund processed"
                ? refundProcessed
                : filterByStatus[i]?.status?.toLowerCase() === "refunded" ? refunded :0;

            modifiedRefundAmount.push({
              ...filterByStatus[i],
              ...{ refundAmount: refundAmount },
            });
          }

          setTokenData(filterByStatus);

          const transformedRows = modifiedRefundAmount?.map((token, i) => ({
            id: i,
            salesPerson: token?.leadId?.userId?.name || "-",
            leadName: token?.leadId || "-",
            eventName: token?.eventId?.title,
            tokenType: token?.eventTokenId?.tokenId?.isPreselect
              ? "Pre-Select"
              : token.eventTokenId?.tokenId?.isPriorityPass
              ? "Priority Pass"
              : "Global Token",
            tokenName: token?.eventTokenId?.tokenId?.name,
            paidAmount: token?.paidAmount ? token?.paidAmount : 0,
            refundAmount: token?.refundAmount ? token?.refundAmount : 0,
            tokenStatus: token || "",
          }));
          const sortedArray = [...transformedRows].sort(
            (a, b) => b?.last_updated_at - a?.last_updated_at
          );

          function calculateTotal(startIndex, endIndex, array) {
            let id = uuidv4();

            let subtotalPaidAmount = 0;
            let subtotalRefundAmount = 0;

            for (let i = startIndex; i <= endIndex; i++) {
              subtotalPaidAmount += array[i]?.paidAmount || 0;

              subtotalRefundAmount += array[i]?.refundAmount || 0;
            }

            return {
              id: id,
              salesPerson: "Sub total",
              leadname: "",
              eventName: "",
              tokenType: "",
              tokenName: "",
              paidAmount: subtotalPaidAmount ? subtotalPaidAmount : 0,
              refundAmount: subtotalRefundAmount ? subtotalRefundAmount : 0,
              tokenStatus: "",
            };
          }

          function addObjectsWithTotals(array, chunkSize) {
            let newArray = [];

            for (let i = 0; i < array.length; i += chunkSize) {
              let endIndex = i + chunkSize - 1;
              if (endIndex >= array.length) {
                endIndex = array.length - 1;
              }

              newArray = newArray.concat(array.slice(i, endIndex + 1));

              newArray.push(calculateTotal(i, endIndex, array));
            }

            return newArray;
          }

          let newArray = addObjectsWithTotals(sortedArray, 10);

          setTokenRows(newArray);

          const columnPayload = [...tokenHeader]
          if(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true){
            columnPayload.unshift({ field: "salesPerson", headerName: "Sales Person", width: 250 })
          }

          setTokenColumns(columnPayload);
            setTimeout(() => {
              dismissLoader();
            }, 300);
        }
      } catch (error) {
        console.error("Error fetching allotments:", error);
        dismissLoader();
      }
    }
  }

  const getSalesPersonData = async () => {
    presentLoader()
    try{
      const salesPerson = await getUsersByTeams((loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? teamIds : [loggedInUser?.userId]);
    const salesPersonArr = [];
    const salesPersonNameArr = [];
    salesPerson?.data?.forEach((s) => {
      salesPersonArr.push({
        label: s?.name,
        value: s?.userId,
      });
      salesPersonNameArr.push({
        label: s?.name,
        value: s?.name,
      });
    });
    setSalesList(salesPersonArr);
    setSalesNameList(salesPersonNameArr);
  
}catch (error) {
console.error("Error fetching sales person:", error);
dismissLoader();
}
  }

  const getEvents = async(salesName)=>{
    presentLoader()
    const salesId = drpDownSubSelectedVal && drpDownSubSelectedVal !== "All" && salesName
    const salesPerson = salesId && getSalesId(salesId)
  try{
  const resp = await getEventBySalesPerson(salesPerson === "All" ? false : salesPerson,(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? teamIds : [loggedInUser?.userId])
  if(resp){
    const eventObj = resp?.data?.map((el) => el?.launchId?.eventId?.title);
    const eventList = resp?.data?.map((el) => ({
      label: el?.launchId?.eventId?.title,
      value: el?.launchId?.eventId?.eventId,
    }));
    const unique = new Set(eventObj)
    const uniqueArr = Array.from(unique)
    const arr = uniqueArr?.map(el=>{
      return {label: el,
         value: el }
    })

    setEventsList(eventList);
    setEventsNameList(arr);
  }

   }catch (error) {
console.error("Error fetching events:", error);
dismissLoader();
}
  }

  const getProjectsData = async () => {
    presentLoader()
    const selectedProjectList = await getSelectedProjectByIds((loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) ? teamIds : [loggedInUser?.userId]);
    const uniqProject = groupBy(selectedProjectList?.data, (v) => v?.projectId);
    const uniqSelectedProjectId = Object.keys(uniqProject)?.map((v) => {
      return v;
    });
    const arr = [];

    if (uniqSelectedProjectId?.length > 0) {
      const projectArr = await getAllProjects();
      projectArr.data.forEach((v) => {
        const index = uniqSelectedProjectId?.findIndex(
          (i) => i === v?.projectId
        );
        if (index !== -1) {
          arr.push({
            label: v?.projectName,
            value: v?.projectId,
          });
        }
      });

      setProjects(arr);
    } else {
      setProjects([]);
    }
    return { arr };
  };


  useEffect(() => {
    presentLoader();
    getSalesPersonData();

    // getEventsData();

    getProjectsData()
      .then(() => {
        presentLoader();

        if (drpDownSelectedVal === "Token") {
          getAllToken(
            url.includes("person")
              ? decodeURIComponent(url.split("?")[5].split("=")[1])
              : "All",
            url.includes("event")
              ? decodeURIComponent(url.split("?")[6].split("=")[1])
              : "All"
          );
          navigate(
            window.location.pathname +
              `?projectName=${url.split("?")[1].split("=")[1]}?startDate=${
                url.split("?")[2].split("=")[1] !== null
                  ? url.split("?")[2].split("=")[1]
                  : 0
              }?endDate=${
                url.split("?")[3].split("=")[1] !== null
                  ? url.split("?")[3].split("=")[1]
                  : 0
              }?type=${drpDownSelectedVal}?person=${drpDownSubSelectedVal}?event=${drpDownEventSelectedVal}`
          );
        } else {
          getAllAllotment(
            url.includes("person")
              ? decodeURIComponent(url.split("?")[5].split("=")[1])
              : "All"
          );
          navigate(
            window.location.pathname +
              `?projectName=${url.split("?")[1].split("=")[1]}?startDate=${
                url.split("?")[2].split("=")[1] !== null
                  ? url.split("?")[2].split("=")[1]
                  : 0
              }?endDate=${
                url.split("?")[3].split("=")[1] !== null
                  ? url.split("?")[3].split("=")[1]
                  : 0
              }?type=${drpDownSelectedVal}?person=${drpDownSubSelectedVal}`
          );
        }
      })
      .catch((err) => {
        dismissLoader();
        console.error("project list err", err);
      });
      getEvents()
  }, []);

  useEffect(() => {
    if (drpDownSelectedVal === "Allotment") {
      getAllAllotment();
    }
    if (drpDownSelectedVal === "Token") {
      getAllToken();
    }
  }, [projects]);

  useEffect(() => {
    if (projects?.length > 0) {
      // setDrpDownSubSelectedVal("All");
      if (drpDownSelectedVal === "Allotment") {
        getAllAllotment();
      }
      if (drpDownSelectedVal === "Token") {
        getAllToken();
      }
    }
  }, [drpDownSelectedVal]);

  useEffect(() => {
    if (projects?.length > 0) {
      if (drpDownSelectedVal === "Allotment") {
        getAllAllotment();
      } else if (drpDownSelectedVal === "Token") {
        getAllToken();
      }
    }
  }, [drpDownSubSelectedVal]);

  useEffect(() => {

    if (projects?.length > 0) {
      if (drpDownSelectedVal === "Allotment") {
        getAllAllotment();
      } else if (drpDownSelectedVal === "Token") {
        getAllToken();
      }
    }
  }, [drpDownEventSelectedVal]);

  useEffect(() => {
    setTimeout(() => {
      if (
        allotmentRows.length > 0 &&
        allotmentRows.length * 72 <
          document.querySelector(
            "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScroller "
          )?.clientHeight
      ) {
        let _1stDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type"
        );
        let _2ndDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone"
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = "fixed";
          _2ndDom.style.height = "100%";
        }
      } else {
        let _1stDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type"
        );
        let _2ndDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone"
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = "sticky";
          _2ndDom.style.height = "unset";
        }
      }
    }, 200);
  }, [allotmentRows]);

  useEffect(() => {
    setTimeout(() => {
      if (
        tokenRows.length > 0 &&
        tokenRows.length * 72 <
          document.querySelector(
            "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScroller "
          )?.clientHeight
      ) {
        let _1stDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type"
        );
        let _2ndDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone"
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = "fixed";
          _2ndDom.style.height = "100%";
        }
      } else {
        let _1stDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone > div:last-of-type"
        );
        let _2ndDom = document.querySelector(
          "#cancellation-and-refund-data-grid .MuiDataGrid-virtualScrollerRenderZone"
        );

        if (_1stDom && _2ndDom) {
          _1stDom.style.position = "sticky";
          _2ndDom.style.height = "unset";
        }
      }
    }, 200);
  }, [tokenRows]);

  const calculateTotal = (arr, type) => {
    let total = 0;
    if (type === "area") {
      total = arr?.reduce((acc, cur) => {
        return acc + cur?.allotmentPaymentId?.unitId?.chargeableArea;
      }, 0.0);
      return total;
    } else if (type === "value") {
      total = arr?.reduce((acc, cur) => {
        if (cur?.allotmentPaymentId?.unitCost?.total) {
          return acc + cur?.allotmentPaymentId?.unitCost?.total;
        } else if (!cur?.allotmentPaymentId?.unitCost?.total) {
          return acc + 0;
        }
      }, 0);
      return total;
    } else if (type === "cp") {
      total = arr?.filter((el) => el?.leadId?.leadType === "CP");

      return total?.length;
    } else if (type === "direct") {
      total = arr?.filter((el) => el?.leadId?.leadType === "Direct");

      return total?.length;
    } else if (type === "r&l") {
      total = arr?.filter((el) => el?.leadId?.leadType === "R&L");

      return total?.length;
    }
    return total;
  };

  function formatNumber(value) {
    if (value >= 10000000) {
      const croreValue = (value / 10000000).toFixed(2);
      return `${croreValue} Cr.`;
    } else {
      const formattedValue = new Intl.NumberFormat("en-IN").format(value);
      return formattedValue;
    }
  }

  function pageChanged(e) {
    if (pageNumber < e) {
      setPageNumber(e);
    }
  }

  function openInNewIcon(detailsArr) {
    setUnitDetails(detailsArr);
    setShowUnitDetailsModal(true);
  }

  const totalTokenRefund = () => {
    let sum = 0;
    for (let i = 0; i < tokenData.length; i++) {

      const refundProcessed = tokenData[
        i
      ]?.eventTokenId?.TokenTransactions?.filter(
        (el) => el?.status?.toLowerCase() === "refund processed" && el?.paymentId === tokenData[i]?.paymentId
      )?.reduce((acc, cur) => acc + cur.amount, 0);

      const refunded = tokenData[
        i
      ]?.eventTokenId?.TokenTransactions?.filter(
        (el) => el?.status?.toLowerCase() === "refunded" && el?.paymentId === tokenData[i]?.paymentId
      )?.reduce((acc, cur) => acc + cur.amount, 0);

      const refundAmount = tokenData[i]?.status?.toLowerCase() === "refund processed"
          ? refundProcessed
          : tokenData[i]?.status?.toLowerCase() === "refunded" ? refunded : 0;
      sum = sum + refundAmount;
    }
    return sum;
  };


  const handleSalesPersonChange = (e) => {
    if (e) {
      const person = e === "All"? e : e?.label 

      setDrpDownSubSelectedVal(person);
      if (drpDownSelectedVal === "Token") {
    getEvents(person)

        navigate(
          window.location.pathname +
            `?projectName=${
              url.split("?")[1].split("=")[1]
            }?startDate=${
              url.split("?")[2].split("=")[1] !== null
                ? url.split("?")[2].split("=")[1]
                : 0
            }?endDate=${
              url.split("?")[3].split("=")[1] !== null
                ? url.split("?")[3].split("=")[1]
                : 0
            }?type=${drpDownSelectedVal}?person=${person}?event=${drpDownEventSelectedVal}`
        );
      } else {
        navigate(
          window.location.pathname +
            `?projectName=${
              url.split("?")[1].split("=")[1]
            }?startDate=${
              url.split("?")[2].split("=")[1] !== null
                ? url.split("?")[2].split("=")[1]
                : 0
            }?endDate=${
              url.split("?")[3].split("=")[1] !== null
                ? url.split("?")[3].split("=")[1]
                : 0
            }?type=${drpDownSelectedVal}?person=${person}`
        );
      }
    }
  };

  const handleEventChange = (e) => {
    if (e)  {
      const eventName = e === "All"? e: e?.label
              setDrpDownEventSelectedVal(eventName);

                  if (drpDownSelectedVal === "Token") {
                    navigate(
                      window.location.pathname +
                        `?projectName=${
                          url.split("?")[1].split("=")[1]
                        }?startDate=${
                          url.split("?")[2].split("=")[1] !== null
                            ? url.split("?")[2].split("=")[1]
                            : 0
                        }?endDate=${
                          url.split("?")[3].split("=")[1] !== null
                            ? url.split("?")[3].split("=")[1]
                            : 0
                        }?type=${drpDownSelectedVal}?person=${drpDownSubSelectedVal}?event=${eventName}`
                    );
                  } else {
                    navigate(
                      window.location.pathname +
                        `?projectName=${
                          url.split("?")[1].split("=")[1]
                        }?startDate=${
                          url.split("?")[2].split("=")[1] !== null
                            ? url.split("?")[2].split("=")[1]
                            : 0
                        }?endDate=${
                          url.split("?")[3].split("=")[1] !== null
                            ? url.split("?")[3].split("=")[1]
                            : 0
                        }?type=${drpDownSelectedVal}?person=${drpDownSubSelectedVal}`
                    );
                  }
    }

    // setDrpDownSubSelectedVal(e.label);

   
  };

  return (
    <Box className={cssClasses.Container}>
      <Box mb={1}>
        <Box className={cssClasses.SubContainer}>
          <Box className={cssClasses.DivContainer}>
            <Box className={cssClasses.HeaderTitle}>Cancellation And Refund</Box>
          </Box>
        </Box>
      </Box>

      <Divider />
      <div className={cssClasses.mainFilter}>
        <div className={cssClasses.subFilter}>
          {" "}
          <div className={cssClasses.dropdownFilter}>
            {" "}
            <DropDown
              list={["Allotment", "Token"]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
                // setDrpDownSubSelectedVal("All");
                setDrpDownEventSelectedVal("All");

                if (_value === "Token") {
                  navigate(
                    window.location.pathname +
                      `?projectName=${
                        url.split("?")[1].split("=")[1]
                      }?startDate=${
                        url.split("?")[2].split("=")[1] !== null
                          ? url.split("?")[2].split("=")[1]
                          : 0
                      }?endDate=${
                        url.split("?")[3].split("=")[1] !== null
                          ? url.split("?")[3].split("=")[1]
                          : 0
                      }?type=${_value}?person=${drpDownSubSelectedVal}?event=${drpDownEventSelectedVal}`
                  );
                } else {
                  navigate(
                    window.location.pathname +
                      `?projectName=${
                        url.split("?")[1].split("=")[1]
                      }?startDate=${
                        url.split("?")[2].split("=")[1] !== null
                          ? url.split("?")[2].split("=")[1]
                          : 0
                      }?endDate=${
                        url.split("?")[3].split("=")[1] !== null
                          ? url.split("?")[3].split("=")[1]
                          : 0
                      }?type=${_value}?person=${drpDownSubSelectedVal}`
                  );
                }
              }}
              placeHolder={"Select"}
              label={"Type : "}
              style={{
                background: "#F2F4F7",
                color: "rgb(102, 112, 133)",
                minWidth: "100px",
              }}
              helperText={""}
            />
          </div>
                {(loggedInUser?.isTeamLead && loggedInUser?.isTeamLead === true) && <div style={{
                     
                     width: "250px",
                     borderRadius: "0.5rem 0.5rem",
                   }} >
          <p className={cssClasses.filterTitle}>Sales Person : </p>
             <CustomAutoComplete
                    NoOptionsText={"No Sales person found"}
                    InitialValue={(e) => {
                      handleSalesPersonChange(e);
                    }}
                    
                    list={["All", ...salesNameList]}
                    multiple={false}
                    disable={false}
                    value={drpDownSubSelectedVal}
                   placeholder="Select Sales Person"
                  />
                  </div>}
          {drpDownSelectedVal === "Token" && (
            <div style={{ width: "250px",
              borderRadius: "0.5rem 0.5rem",
            }} >
   <p className={cssClasses.filterTitle}>Event : </p>
      <CustomAutoComplete
             NoOptionsText={"No Event found"}
             InitialValue={(e) => {
               handleEventChange(e);
             }}
             
             list={["All", ...eventsNameList]}
             multiple={false}
             disable={false}
             value={drpDownEventSelectedVal}
            placeholder="Select Event"
           />
           </div>
          )}
        </div>

        {drpDownSelectedVal === "Token" && (
          <div className={cssClasses.totalPriceToken}>
            <div className={cssClasses.totalHeader}>
              <h1>Total</h1>
            </div>
            <hr />
            <div className={cssClasses.totalAmount}>
              <p className={cssClasses.priceTextHeader}>Total Refund Amount</p>
              <p className={cssClasses.priceText}>
                {formatNumber(totalTokenRefund())}
              </p>
            </div>
          </div>
        )}
      </div>{" "}
      <div
        className={cssClasses.gridWrapper}
        id="cancellation-and-refund-data-grid"
      >
        {drpDownSelectedVal === "Allotment" && allotmentRows.length > 1 ? (
          <Datagrid
            pageChanged={pageChanged}
            hideFooter={false}
            columns={allotmentProjectHeader}
            rows={allotmentRows}
            drpDownSelectedVal={drpDownSelectedVal}
            CancellationsAndRefunds={allotmentRows.length}
            style={{
              ".MuiDataGrid-virtualScrollerRenderZone > div:last-of-type": {
                backgroundColor: "#f9fafb",
                fontWeight: "600",
                color: "#707b9a",
                fontSize: "1.8rem",
                position: "sticky",
                bottom: "0",
                borderTop: "1px solid lightGrey",
                boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.3)",
              },
            }}
          />
        ) : drpDownSelectedVal === "Token" && tokenRows.length > 0 ? (
          <Datagrid
            pageChanged={pageChanged}
            hideFooter={false}
            columns={tokenColumns}
            rows={tokenRows}
            drpDownSelectedVal={drpDownSelectedVal}
            CancellationsAndRefunds={11}
            style={{
              ".MuiDataGrid-virtualScrollerRenderZone > div:last-of-type": {
                backgroundColor: "#f9fafb",
                fontWeight: "600",
                color: "#707b9a",
                fontSize: "1.8rem",
                position: "sticky",
                bottom: "0",
                borderTop: "1px solid lightGrey",
                boxShadow: "1px 1px 1px 1px rgba(0,0,0,0.3)",
              },
            }}
          />
        ) : (
          <div className={cssClasses.noDataWrapper}>
            <div className={cssClasses.noDataMsg}>
              <div className={cssClasses.emptyIcon}>
                <img src={EmptyListIcon} alt="No Requests" />
              </div>
              <div className={cssClasses.emptyTitle}>
                No Cancellations and Refunds to show!
              </div>
            </div>
          </div>
        )}
      </div>
      {showUnitDetailsModal && (
        <CancellationsAndRefundsModal
          data={unitDetails}
          open={showUnitDetailsModal}
          closeHandler={() => setShowUnitDetailsModal(false)}
        />
      )}
    </Box>
  );
}
